export default __webpack_public_path__ + "img/reddit_hover.7d26b87c31ab6fb8c75f6e048a70571c.svg";